module.exports = "../images/arrow-lb-left.png";